"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.badNewsWordsData = void 0;
exports.badNewsWordsData = [
    'recuam',
    'na mira',
    'cai',
    'perda de fôlego',
    'desaba',
    'queda',
    'baixa',
    'caem',
    'corta',
    'recua',
    'fracassou',
    'queda',
    'quedas',
    'pouca liquidez',
    'forte queda',
    'unicórnio',
    'ruim',
    'baixo',
    'prejuízo',
    'altas consecutivas',
    'fraco',
    'fracos',
    'disputa',
    'maiores baixas',
    'operam em queda',
    'forte baixa',
    'lidera quedas',
    'resultado fraco',
    'cair',
    'ruim',
    'caíram',
    'vai cair',
    'abaixar',
    'negativo',
];
//# sourceMappingURL=bad-news-words.data.js.map